import React from "react";
import { BsTwitter, BsInstagram, BsLinkedin } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

const SocialMedia = () => {
  return (
    <>
      <div className="app__social">
        <div className="">
          <a href="https://twitter.com/shahzaibktk0312" target="_blank">
            <BsTwitter />
          </a>
        </div>
        <div className="">
          <a
            href="https://www.instagram.com/muhammad.shahzaib.5011516/"
            target="_blank"
          >
            <BsInstagram />
          </a>
        </div>
        <div className="">
          <a
            href="https://www.linkedin.com/in/muhammad-shahzaib0312/"
            target="_blank"
          >
            <BsLinkedin />
          </a>
        </div>
      </div>
    </>
  );
};

export default SocialMedia;
